import axios from "axios";
import vSelect from "vue-select";
export default {
  name: "CafeItemsComponent",
  components: {
    vSelect
  },
  data() {
    return {
      items: [],
      categories: [],
      fields: [{
        key: "item_id",
        label: "ID",
        sortable: true
      }, {
        key: "item_name",
        label: "Nom",
        sortable: true
      }, {
        key: "item_cat",
        label: "Catégorie",
        sortable: true
      }, {
        key: "item_price",
        label: "Prix",
        sortable: true
      }, {
        key: "actions",
        label: "",
        class: "text-right"
      }],
      selectedItem: null,
      selectedItemCopy: null,
      selectedItemImage: null,
      selectedItemPreviewImage: null,
      modalId: "add-item-modal",
      modalItem: {
        item_name: "",
        item_price: 0,
        item_cat: "",
        item_image: null
      },
      modalPreviewImage: null,
      detailImageFile: null,
      searchQuery: ""
    };
  },
  computed: {
    filteredItems() {
      if (!this.searchQuery) {
        return this.items;
      }
      const query = this.searchQuery.toLowerCase();
      return this.items.filter(item => item.item_name && item.item_name.toLowerCase().includes(query) || item.item_cat && item.item_cat.toLowerCase().includes(query));
    }
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    fetchItems() {
      axios.get(`${this.$store.state.api_url}/cafe_items`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        this.items = response.data;
        const cats = new Set(this.items.map(i => i.item_cat));
        this.categories = Array.from(cats);
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          this.error();
        } else {
          console.error(err);
        }
      });
    },
    selectItem(item) {
      this.selectedItem = item;
      this.selectedItemCopy = {
        ...item,
        item_image: null
      };
      this.selectedItemPreviewImage = null;
      this.fetchItemImage(item.item_id);
    },
    resetSelection() {
      this.selectedItem = null;
      this.selectedItemCopy = null;
      this.selectedItemImage = null;
      this.selectedItemPreviewImage = null;
      this.detailImageFile = null;
    },
    onDetailImageSelected(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          const base64Data = e.target.result.split(",")[1];
          this.selectedItemCopy.item_image = base64Data;
          this.selectedItemPreviewImage = e.target.result; // Show preview of new image
        };
        reader.readAsDataURL(file);
      } else {
        this.selectedItemCopy.item_image = null;
        this.selectedItemPreviewImage = null;
      }
    },
    updateSelectedItem() {
      if (!this.selectedItemCopy) return;
      axios.put(`${this.$store.state.api_url}/cafe_items/${this.selectedItemCopy.item_id}`, this.selectedItemCopy, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(() => {
        this.$bvToast.toast("Modifié avec succès", {
          title: "Succès",
          variant: "success",
          solid: true
        });
        this.fetchItems();
        this.selectedItem = {
          ...this.selectedItemCopy,
          item_image: null
        };
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          this.error();
        } else {
          this.$bvToast.toast("Erreur lors de la modification", {
            variant: "danger",
            solid: true
          });
          console.error(err);
        }
      });
    },
    promptAddItem() {
      this.modalItem = {
        item_name: "",
        item_price: 0,
        item_cat: "",
        item_image: null
      };
      this.modalPreviewImage = null;
      this.$root.$emit("bv::show::modal", this.modalId);
    },
    onModalImageSelected(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          const base64Data = e.target.result.split(",")[1];
          this.modalItem.item_image = base64Data;
          this.modalPreviewImage = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.modalItem.item_image = null;
        this.modalPreviewImage = null;
      }
    },
    addNewItem() {
      axios.post(`${this.$store.state.api_url}/cafe_items`, this.modalItem, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(() => {
        this.$bvToast.toast("Ajouté avec succès", {
          title: "Succès",
          variant: "success",
          solid: true
        });
        this.fetchItems();
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          this.error();
        } else {
          this.$bvToast.toast("Erreur lors de l'ajout", {
            variant: "danger",
            solid: true
          });
          console.error(err);
        }
      }).finally(() => {
        this.$root.$emit("bv::hide::modal", this.modalId);
      });
    },
    resetModal() {
      this.modalItem = {
        item_name: "",
        item_price: 0,
        item_cat: "",
        item_image: null
      };
      this.modalPreviewImage = null;
    },
    fetchItemImage(item_id) {
      axios.get(`${this.$store.state.api_url}/cafe_items/${item_id}/image`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        },
        responseType: 'arraybuffer'
      }).then(response => {
        if (response.status === 200) {
          const base64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          this.selectedItemImage = `data:image/png;base64,${base64}`;
        } else {
          this.selectedItemImage = null;
        }
      }).catch(err => {
        this.selectedItemImage = null;
        if (err.response && err.response.status !== 404) {
          console.error("Error fetching image:", err);
        }
      });
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm("Confirmez la suppression de l'article?", {
        title: "Confirmez SVP",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "Oui",
        cancelTitle: "Non",
        footerClass: "p-2",
        centered: true
      }).then(value => {
        if (value) {
          axios.delete(`${this.$store.state.api_url}/cafe_items/${item.item_id}`, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token
            }
          }).then(() => {
            this.$bvToast.toast("Supprimé avec succès", {
              title: "Succès",
              variant: "success",
              solid: true
            });
            this.fetchItems();
            if (this.selectedItem && this.selectedItem.item_id === item.item_id) {
              this.resetSelection();
            }
          }).catch(err => {
            if (err.response && err.response.status === 401) {
              this.error();
            } else {
              this.$bvToast.toast("Erreur lors de la suppression", {
                variant: "danger",
                solid: true
              });
              console.error(err);
            }
          });
        }
      }).catch(err => {
        console.error(err);
      });
    },
    deleteSelectedItem() {
      if (!this.selectedItem) return;
      this.deleteItem(this.selectedItem);
    },
    formatPrice(value) {
      return `${Number(value).toFixed(2)} €`;
    },
    error() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    }
  }
};